<template>
  <v-navigation-drawer v-model="drawerV" absolute temporary style="z-index:100000">
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title class="title">
          {{ getFirstPracticeIntroTitleandSetHtml() }}
        </v-list-item-title>
        <v-list-item-subtitle>
          Algetec | <a class="link" href="https://www.imersys.com">Imersys</a>
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <v-divider />
    <v-stepper v-model="this.$store.state.app.drawer" vertical>
      <v-stepper-step :complete="e6 > 1" step="1">
        {{ getTranslation('Início', 'Inicio') }}
      </v-stepper-step>

      <v-stepper-content step="1" />

      <v-stepper-step :complete="e6 > 2" step="2">
        {{ getTranslation('Apresentação da Atividade', 'Presentación de la actividad') }}
        
      </v-stepper-step>

      <v-stepper-content step="2" />

      <v-stepper-step :complete="e6 > 3" step="3">
        {{ getTranslation('Seleção de Materiais', 'Selección de Materiales') }}
      </v-stepper-step>

      <v-stepper-content step="3" />

      <v-stepper-step :complete="e6 > 4" step="4">
        {{ getTranslation('Atividades', 'Actividades') }}
      </v-stepper-step>

      <v-stepper-content step="4" />

      <v-stepper-step :complete="e6 > 5" step="5">
        {{ getTranslation('Exercícios', 'Ejercicios') }}
      </v-stepper-step>


      <v-stepper-content step="5" />
    </v-stepper>
  </v-navigation-drawer>
</template>

<script>
import Const from "@/helpers/const";
import { mapMutations } from "vuex";
let json = require("../../json/pratica-" + Const.PRACTICE_NUMBER + ".json");
export default {
  data() {
    return {
      json: json,
    };
  },
  computed: {
    e6: {
      get() {
        return this.$store.state.app.stepper;
      },
      set(val) {
        this.setStepper(val);
      },
    },
    drawerV: {
      get() {
        return this.$store.state.app.drawer;
      },
      set(val) {
        this.setDrawer(val);
      },
    },
  },
  methods: {
    getFirstPracticeIntroTitleandSetHtml() {
      const pratica1 = this.json.pratica[0];

      // Set HTML page title
      document.title = pratica1.introducao.titulo + " - Algetec | Imersys";

      return pratica1.introducao.titulo;
    },
    getTranslation(elementPortuguese, elementSpanish){
      
      if(Const.PRACTICE_NUMBER.includes('es')){
        return elementSpanish
      }

      return elementPortuguese
    },
    ...mapMutations("app", ["setDrawer", "toggleDrawer"]),
  },
};
</script>

<style>
.link,
.link:visited,
.link:active {
  color: rgb(184, 184, 184);
  -webkit-transition: color 0.5s;
  /* For Safari 3.0 to 6.0 */
  transition: color 0.5s;
  /* For modern browsers */
  text-decoration: none;
}

.link:hover {
  color: white;
}

/* CSS link hover (green) */

/* width */
::-webkit-scrollbar {
  width: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #363636;
  border-radius: 2px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #666666;
  border-radius: 2px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>
